import React from "react"; // eslint-disable-line no-unused-vars
import "./ExpressiveKeyboard.css";

const ExpressiveKeyboard = () => {
  return (
    <>
      {/* <div className="expressiveCard">
        <ApplyModuleCard
          para={para}
          name={name}
          country={country}
          src={src}
          picJaqu={pic}
          poster={poster}
        />
      </div> */}
    </>
  );
};

export default ExpressiveKeyboard;
